import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import InstallPrompt from './components/InstallPrompt';
import BodyPartPage from './pages/BodyPartPage';
import ExercisePage from './pages/ExercisePage';
import RecordPage from './pages/RecordPage';
import HistoryPage from './pages/HistoryPage';
import GraphPage from './pages/GraphPage';
import ExerciseManagePage from './pages/ExerciseManagePage';

const App = () => (
  <BrowserRouter>
    <div className="app">
      <Routes>
        <Route path="/" element={<BodyPartPage />} />
        <Route path="/exercises/:bodyPart" element={<ExercisePage />} />
        <Route path="/record/:bodyPart/:exercise" element={<RecordPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/manage" element={<ExerciseManagePage />} />
      </Routes>
      <Navigation />
      <InstallPrompt />
    </div>
  </BrowserRouter>
);

export default App;
